export const brandName = "ALAIRA HOUSE";
export const brandTagline = "Long-Distance Love, Beautifully Delivered";
export const brandEmail = "support@alairahouse.com";
export const brandPhone = "+91 78419 28485";
export const brandAddressLines = [
  "Alaira House Studio,",
  "Suite 101, Pastel Towers,",
  "Near Love Lock Bridge,",
  "Wai, Maharashtra 412803",
];
export const brandInstagramUrl = "https://www.instagram.com/alairahouse";
export const brandInstagramHandle = "@alairahouse";
export const brandLogoPath = "/assets/logo.png";
export const brandHeroBackgroundPath = "/assets/homepage background.png";
export const brandHeroArtworkPath = "/assets/home page.png";
export const brandSeoDescription =
  "ALAIRA HOUSE — Luxury long-distance love gifts. Send warmth, sweetness, and softness across any miles.";
